import React from "react";
import { Table, Card } from "react-bootstrap";
import _ from "lodash";

export const AddressDetails = ({ addressDetails }) => {
  return (
    <div className="container">
      <Card.Header className="accordian-header">ADDRESS</Card.Header>
      <div className="container mt-3">
        {addressDetails && addressDetails.length ? (
          addressDetails.map(function (address, id) {
            return (
              <div key={id}>
                <h6 className="text-left">
                  {_.upperFirst(address.addressType)} Address
                </h6>
                <div className="container mt-3">
                  <div className="col report text-center">
                    <Table striped bordered hover size="sm">
                      <tr>
                        <td align="left">
                          <strong>Address Line 1 : </strong>
                          {address.addressLine1}
                        </td>
                        <td align="left" colSpan="2">
                          <strong>Address Line 2 : </strong>
                          {address.addressLine2}
                        </td>
                      </tr>
                      <tr>
                        <td align="left">
                          <strong>Locality : </strong>
                          {address.locality}
                        </td>
                        <td align="left">
                          <strong>City : </strong> {address.city}
                          {" - "}
                          {address.pincode}
                        </td>
                        <td align="left">
                          <strong>State : </strong> {address.state}
                        </td>
                      </tr>
                    </Table>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-center">Address Details are not available</p>
        )}
        <br />
      </div>
    </div>
  );
};

export default AddressDetails;
